import Spinner from 'GeneralUI/Spinner/Spinner.jsx'

// Loading has been moved to Spinner with its related components but this here for backward compatibility
const Loading = Spinner

export default Loading
